/*
  Free-gift guard (2026-10-18). The castor value page (L003) adds a free jojoba line tagged with the
  line property _ee_gift, and the code CASTORJOJOBA prices it at $0. When the code stops applying
  (the castor is removed or swapped in the cart drawer, or another code replaces it) Shopify would
  charge the jojoba at full price. This removes any _ee_gift line the cart prices above $0.
  It runs site-wide because the cart drawer can change the cart on any page, and it only looks
  after every cart request in flight has finished. It also waits while window.__eeGiftBusyUntil is
  in the future: the 800 ms quiet period alone did not cover the page's own cart read between the
  add and the code (v7, 2026-10-20, after order #3929 lost its gift on a slow phone).
*/
(function () {
  if (window.__eeGiftGuard) return;
  window.__eeGiftGuard = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var pending = 0;
  var timer = null;
  var checking = false;
  var CART_URL = /\/cart(\/(add|change|update|clear))?(\.js)?(\?|$)|\/discount\//;

  function isCartCall(url) {
    return CART_URL.test(String(url || '')) && !/\/cart\.js/.test(String(url || ''));
  }

  function refreshDrawer() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    try {
      if (window.Rebuy && window.Rebuy.Cart && typeof window.Rebuy.Cart.fetchCart === 'function') {
        window.Rebuy.Cart.fetchCart();
      }
    } catch (e) {}
  }

  function check() {
    if (checking || pending > 0) return;
    // A landing page's add-and-apply-code sequence is still running (ee-lp.js sets this, 15 s max).
    if ((window.__eeGiftBusyUntil || 0) > Date.now()) { schedule(); return; }
    checking = true;
    origFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var n = 0;
        (cart.items || []).forEach(function (item) {
          if (item.properties && item.properties._ee_gift && item.final_line_price > 0) {
            updates[item.key] = 0;
            n++;
          }
        });
        if (!n) return false;
        return origFetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { return true; });
      })
      .then(function (changed) { if (changed) refreshDrawer(); })
      .catch(function () {})
      .then(function () { checking = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 800);
  }

  function started() {
    pending++;
    clearTimeout(timer);
  }

  function finished() {
    pending = Math.max(0, pending - 1);
    if (pending === 0) schedule();
  }

  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!origFetch) return;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (!isCartCall(url)) return origFetch(input, init);
    started();
    var p = origFetch(input, init);
    p.then(finished, finished);
    return p;
  };

  var open = XMLHttpRequest.prototype.open;
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__eeCart = isCartCall(url);
    return open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__eeCart) {
      started();
      this.addEventListener('loadend', finished);
    }
    return send.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
})();
